import { render, staticRenderFns } from "./AwardsReport.vue?vue&type=template&id=74977f1a"
import script from "./AwardsReport.vue?vue&type=script&lang=js"
export * from "./AwardsReport.vue?vue&type=script&lang=js"
import style0 from "./AwardsReport.vue?vue&type=style&index=0&id=74977f1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports